import React from 'react';

const PublicWorks = () => {
    return (
        <div className="industry-section">
            <div className="industry-content">
                <h2>Public Works</h2>
                <p>
                    Our LiDAR solutions help public works departments with infrastructure planning, maintenance, and urban development. From road surface analysis to bridge inspection and flood mapping, our technology provides precise measurements for better decision-making.
                </p>
                <p>
                    High-resolution scans detect subtle changes in infrastructure over time, allowing for preventative maintenance and more efficient resource allocation.
                </p>
                <div className="industry-features">
                    <span className="feature-item">Road Surface Analysis</span>
                    <span className="feature-item">Bridge Inspection</span>
                    <span className="feature-item">Urban Planning</span>
                    <span className="feature-item">Flood Mapping</span>
                    <span className="feature-item">Asset Management</span>
                </div>
            </div>
            <div className="industry-image">
                <img src="/img/industries/public-works.png" alt="Public Works LiDAR Application" />
            </div>
        </div>
    );
};

export default PublicWorks;
